import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Sidebar from "./sidebar";
import BeneficiarySearch from "./BeneficiarySearch";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const optionLabel = (option) =>
  option ? `${option.firstName || ""} ${option.surName || ""}`.trim() : "";

export default function DailyRegister() {
  const [date, setdate] = useState("");
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [attendees, setattendees] = useState([null]);
  const [saving, setsaving] = useState(false);

  useEffect(() => {
    const loadBeneficiaries = async () => {
      const querySnapshot = await getDocs(collection(db, "employee"));
      const list = [];
      querySnapshot.forEach((document) => {
        const e = document.data();
        list.push({
          id: document.id,
          firstName: e.firstName || "",
          surName: e.surName || "",
          gender: e.gender || "",
          postCode: e.postCode || "",
          DOB: e.DOB || "",
        });
      });
      list.sort((a, b) =>
        optionLabel(a).localeCompare(optionLabel(b), undefined, {
          sensitivity: "base",
        })
      );
      setBeneficiaries(list);
    };
    loadBeneficiaries();
  }, []);

  useEffect(() => {
    if (!date) return;
    const loadRegister = async () => {
      const snapshot = await getDoc(doc(db, "dailyRegister", date));
      if (snapshot.exists()) {
        const data = snapshot.data();
        const saved = Array.isArray(data.attendees) ? data.attendees : [];
        setattendees(saved.length > 0 ? saved : [null]);
      } else {
        setattendees([null]);
      }
    };
    loadRegister();
  }, [date]);

  const updateAttendee = (index, value) => {
    setattendees((current) =>
      current.map((attendee, i) => (i === index ? value : attendee))
    );
  };

  const addAttendee = () => setattendees((current) => [...current, null]);

  const removeAttendee = (index) => {
    setattendees((current) =>
      current.length === 1
        ? current
        : current.filter((_, i) => i !== index)
    );
  };

  const saveRegister = async () => {
    if (!date) {
      alert("Please select a date.");
      return;
    }
    const list = attendees
      .filter(Boolean)
      .map((attendee) => {
        const match = beneficiaries.find((b) => b.id === attendee.id);
        return {
          id: attendee.id,
          firstName: attendee.firstName || "",
          surName: attendee.surName || "",
          gender: attendee.gender || (match ? match.gender : "") || "",
        };
      });

    setsaving(true);
    try {
      await setDoc(doc(db, "dailyRegister", date), {
        date,
        attendees: list,
        updatedAt: serverTimestamp(),
      });
      alert("Daily register saved.");
    } catch (error) {
      alert("Could not save the daily register: " + error.message);
    } finally {
      setsaving(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        style={{ marginTop: "50px" }}
      >
        <div style={{ width: "100%" }}>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Daily Register
          </Typography>

          <TextField
            type="date"
            label="Date"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            style={{ width: "45%", marginBottom: "20px" }}
            value={date}
            onChange={(e) => setdate(e.target.value)}
          />

          <Typography variant="h6" sx={{ mb: 1 }}>
            Attendees
          </Typography>

          {attendees.map((attendee, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
            >
              <BeneficiarySearch
                options={beneficiaries}
                value={attendee}
                onChange={(value) => updateAttendee(index, value)}
                getOptionLabel={optionLabel}
                getOptionSecondary={(option) =>
                  option.DOB
                    ? `DOB ${option.DOB}`
                    : option.postCode
                    ? `Postcode ${option.postCode}`
                    : ""
                }
                label={`Attendee ${index + 1}`}
                placeholder="Type a name"
                noOptionsText="No beneficiaries found"
                sx={{ flex: 1 }}
              />
              <IconButton
                onClick={() => removeAttendee(index)}
                disabled={attendees.length === 1}
                aria-label="Remove attendee"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

          <Button
            startIcon={<AddIcon />}
            onClick={addAttendee}
            variant="outlined"
            style={{ marginTop: "10px" }}
          >
            Add Attendee
          </Button>

          <Typography sx={{ mt: 3, mb: 2, color: "text.secondary" }}>
            {attendees.filter(Boolean).length} attendee
            {attendees.filter(Boolean).length === 1 ? "" : "s"} selected
          </Typography>

          <Button
            onClick={saveRegister}
            variant="contained"
            disabled={saving}
            style={{
              width: "100%",
              height: "50px",
              backgroundColor: "#F21D2F",
            }}
          >
            {saving ? "Saving..." : "Save Register"}
          </Button>
        </div>
      </Box>
    </Box>
  );
}
